import React from 'react';

const Footer = () => { 
    return (
        <footer className=" py-3">
            <p className="text-center">
                Copyright &copy; AI Infotech Solutions All rights reserved | Design by Rajvardhan & Amol.
            </p>
            <div className="text-center">
                <a href="https://www.facebook.com/profile.php?id=61578102849260" target="_blank" rel="noopener noreferrer" className="icon"><i className='fab fa-facebook-f'></i></a>
                <a href="https://www.instagram.com/aiinfotechsolutions97/" target="_blank" rel="noopener noreferrer" className="icon"><i className='fab fa-instagram'></i></a>
            </div>
        </footer>
    );
}

export default Footer;
